import { createContext, useMemo, useState } from 'react'

const InputContext = createContext()

function InputProvider({ children }) {
  const [isValid, setIsValid] = useState(null)
  const [isInvalid, setIsInvalid] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const value = useMemo(() => {
    return {
      valid: [isValid, setIsValid],
      invalid: [isInvalid, setIsInvalid],
      errorMessage: [errorMessage, setErrorMessage],
    }
  }, [isValid, isInvalid, errorMessage])

  return <InputContext.Provider value={value}>{children}</InputContext.Provider>
}

export { InputContext, InputProvider }
